<div class="common-wrapper">
    <div class="main-hd-txt">
        <h4>
            <pageheader [entity]="headerMeeting"></pageheader>
        </h4>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="Meeting.data" [actionExclude]="['feedback','column']" [checkboxCol]="true"
        [entityColumns]="MeetingColumns" [selectionField]="'Meeting_Id'" [addEntityIcon]="'bi bi-plus-square'"
        [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (addEntity)="addMeeting($event)"
        (downloadEntities)="onExcelExport()" (editEntity)="editMeeting($event)"
        (refreshEntities)="refreshDepartments($event)" (deleteEntity)="deleteMeeting($event)" 
        (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
        [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)" >
    </grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearMeeting()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Meeting Group'" [formData]="entity" [data]="employees" [class] = "'form-control'"
                    [mandatory]="false" [filterable]="true" (filterChanged)="getAllMeeting_type($event)"
                    [(ngModel)]="entity.MeetingType_Id" [textField]="'MeetingTypeName'" [valueField]="'MeetingType_Id'"
                    [fieldName]="'MeetingTypeName'" [selectedItem]="selectedmeeting" ngDefaultControl>
                </dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Meeting Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                    [fieldName]="'MeetingName'" [(ngModel)]="entity.MeetingName " ngDefaultControl>
                </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Description'" [multiline]="true" [formData]="entity" [maxlength]="500" [mandatory]="true"
                    [fieldName]="'MeetingDescription'" [(ngModel)]="entity.MeetingDescription"  ngDefaultControl>
                </textbox>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div>
        </div>
       
    </div>
</div>

<kendo-excelexport [data]="Meeting.data" [collapsible]="true" fileName="MeetingtypeMaster.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="MeetingName" title="Meeting Name" [width]="200">
    </kendo-excelexport-column>  
    <kendo-excelexport-column field="MeetingDescription" title="Description" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 
</kendo-excelexport>